import { Injectable } from '@angular/core';
import { JsonSerializable } from './jsonSerializable';
import { ProductClass } from '../entity/product-class';
import { Product } from '../entity/product';
import { Package } from '../entity/package';
import { Request } from '../entity/request';
import { ResultDu } from '../entity/result-du';
import { Sample } from '../entity/sample';
import { ThirdParty } from '../entity/third-party';

@Injectable()
export class LocalStorageService {

  save(directory, name, data) {
    let localDataJson = localStorage.getItem(directory);
    let localData = null;
    if (localDataJson) {
      localData = JSON.parse(localDataJson);
    } else {
      localData = {};
    }

    localData[name] = data;

    localStorage.setItem(directory,JSON.stringify(localData))
  }

  get(directory, name, classname) {
    let data = JSON.parse(localStorage.getItem(directory));
    if (!data) {
      return undefined;
    }
    if (name) {
      if (data.hasOwnProperty(name)) {
        if (Array.isArray(data[name])) {
          let array = new Array();
          for (let i in data[name]) {
            let instance = this.createInstance(classname);
            if (instance) {
              instance.fromJSON(data[name][i]);
              array[i] = instance;
            } else {
              array[i] = data[name][i];
            }
          }
          return array;
        } else {
          let instance = this.createInstance(classname);
          if (instance) {
            instance.fromJSON(data[name]);
            return instance;
          }
          return data[name];
        }        
      } else {
        return null;
      }
    }
    return data ;
  }

  clear(directory, name){
    if (name==null) {
      localStorage.removeItem(directory);
    } else {
      let data = JSON.parse(localStorage.getItem(directory));
      if (data[name]) {
        delete data[name];
      }
      localStorage.setItem(directory,JSON.stringify(data));
    }    
  }

  createInstance(className): JsonSerializable
  {
    let ctors: { [name: string]: ControlLogicConstrctor } = {
      "ThirdParty": ThirdParty,
      "ResultDu": ResultDu,
      "Product": Product,
      "Package" : Package,
      "ProductClass" : ProductClass,
      "Request" : Request,
      "Sample": Sample
    }

    let ctor = ctors[className];

    if (!ctor) {
        return null;
    }

    return new ctor();
  }

}

interface ControlLogicConstrctor {
    new (): JsonSerializable;
}


// WEBPACK FOOTER //
// ./src/app/shared/local-storage.service.ts